import Token from "../util/token";

const initialUser = {
    name: '',
    role: '',
    initials: ''
};

export default (state = {...initialUser}, action) => {
    switch (action.type) {
        case 'LOGIN': {
            const token = Token.decode(action.payload.token);
            return {
                ...state,
                name: token.name,
                role: token.role,
                initials: token.initials
            };
        }
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/user.js